import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const CloseButton = css`
  color: ${theme.colors.darkBlues[50]};
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.lineHeights[6]};
  margin: 0;
  text-align: right;

  i {
    cursor: pointer;
  }
`;

export const ButtonHoverStateStyle = css`
  &:hover {
    background-color: transparent;
    color: ${theme.colors.blues[125]};
    text-decoration: underline;

    i {
      background-color: transparent;
      color: ${theme.colors.blues[125]};
      text-decoration: underline;
    }
  }
`;

export const LineItemFormContainer = css`
  fieldset {
    border: 0;
    margin: 0;
    min-width: 0;
    padding: 0;
  }

  .form-group {
    margin-bottom: ${theme.space[4]};
    &:last-child {
      margin-bottom: 0;
    }
  }

  legend {
    font-size: ${theme.fontSizes[3]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights[4]};
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #e6e9ec;
    padding-bottom: 1em;
  }

  label {
    display: block;
    font-size: ${theme.fontSizes[0]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights[1]};
    margin-bottom: ${theme.space[1]};
  }

  .error-detail.bs-callout.bs-callout-info,
  label.control-label,
  button.btn.btn-info {
    display: none;
  }

  input {
    width: 100%;
  }

  textarea {
    width: calc(100% - ${theme.space[5]});
  }

  p.field-description {
    border-bottom: 1px solid ${theme.colors.darkBlues[10]};
    color: ${theme.colors.darkBlues[75]};
    font-size: ${theme.fontSizes[2]};
    margin-block-start: 0em;
    margin-bottom: ${theme.space[5]};
    padding-bottom: ${theme.space[5]};
  }

  ${theme.mediaQueries.medium} {
    input {
      width: 100%;
    }

    textarea {
      width: calc(100% - ${theme.space[5]});
    }
  }

  .buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: ${theme.space[3]};
  }
`;

export const SlideOverContainer = css`
  [data-isopen="true"] {
    width: 360px;
    overflow: hidden;
    overflow-y: auto;
  }

  [data-isopen="false"] {
    width: 360px;
    right: -360px;
    transition: right 0.2s ease-in;
  }
`;

export const SlideOverStyling = css`
  padding: ${theme.space[6]};

  input,
  select {
    width: 100%;
  }

  textarea {
    width: calc(100% - ${theme.space[5]});
  }

  .buttons-container {
    box-sizing: border-box;
    margin-top: ${theme.space[5]};
    text-align: right;
    width: 100%;
  }

  .buttons-container button:not(:last-child) {
    margin-right: ${theme.space[2]};
  }
`;

export const FormFooter = styled.div`
  border-top: 1px solid ${theme.colors.darkBlues[10]};
  padding-top: ${theme.space[5]};
`;
